// extracted by mini-css-extract-plugin
export default {"fullWidth":"cn-z","image":"dn-z","lazyLoadPicture":"en-z","lazyLoadSpinner":"fn-z","lazyLoadSpin":"gn-z","lazyLoadImage":"hn-z","hasStyledAspectRatio":"in-z"};